import { FGNumberInput, FGSelectInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGSRSHDateMaskInput } from "../../../../components";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";

export interface IDrupalMiscellaneousRequestFormProps {
  miscellaneousRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalMiscellaneousRequestForm: React.FunctionComponent<IDrupalMiscellaneousRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const [articles, aloading] = useReferential(
    (a) => a.getArticles(false),
    true,
    []
  );

  const { t } = useTl();
  return (
    <>
      <DrupalFormGenerator
        initialValues={initialdata}
        editMode={false}
        onSubmit={() => {}}
        loading={loading}
        saving={false}
        deleting={false}
        hideButtons
      >
        <FieldGroup
          columns={2}
          fieldsetProps={{ title: t(ETLCodes.RequestData) }}
        >
          <div>
            <FGSRSHDateMaskInput
              name="request.requestDate"
              label={t(ETLCodes.RequestDate)}
            />
            {initialdata?.request?.status === ERequestState.EXECUTED && (
              <FieldGroup columns={2}>
                <FGSRSHDateMaskInput
                  name="request.executionDate"
                  label={t(ETLCodes.ClosingDate)}
                />
              </FieldGroup>
            )}
          </div>
        </FieldGroup>

        <FieldGroup columns={2}>
          <FGSelectInput
            name="articleId"
            label={t(ETLCodes.Article)}
            items={articles}
            loading={aloading}
          />
          <FGNumberInput name="quantity" label={t(ETLCodes.Quantity)} />
        </FieldGroup>
        <DrupalStepperButtonBloc backOnly={true} />
      </DrupalFormGenerator>
    </>
  );
};
